/** 第三方商品库明细扩展字段（侵权风险、刊登状态等），本地持久化 */
import { userLocal } from '@/utils/ipeUserLocalState';

const STORAGE_KEY = 'ipe-receive-item-meta-v1';
export const RECEIVE_ITEM_META_EVENT = 'ipe-receive-item-meta-changed';

export function readReceiveMetaMap() {
  try {
    const o = userLocal.getJson(STORAGE_KEY, {});
    return typeof o === 'object' && o && !Array.isArray(o) ? o : {};
  } catch {
    return {};
  }
}

function writeReceiveMetaMap(map) {
  userLocal.setJson(STORAGE_KEY, map);
}

function asStringArray(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || '').trim()).filter(Boolean);
  }
  if (typeof value === 'string' && value.trim()) {
    return value.split(/[,，;；\s]+/).map((item) => item.trim()).filter(Boolean);
  }
  return [];
}

/** @returns {object} */
export function getReceiveItemMeta(id) {
  const row = readReceiveMetaMap()[String(id)] || {};
  return {
    risk: typeof row.risk === 'string' ? row.risk : 'pending',
    listed: Boolean(row.listed),
    listingJobPending: Boolean(row.listingJobPending),
    listingFailed: Boolean(row.listingFailed),
    listingJobId: row.listingJobId != null ? Number(row.listingJobId) : null,
    listingSourcingItemId: row.listingSourcingItemId != null ? Number(row.listingSourcingItemId) : null,
    listingLog: typeof row.listingLog === 'string' ? row.listingLog : '',
    listingPlatformSpu: typeof row.listingPlatformSpu === 'string' ? row.listingPlatformSpu : '',
    listingPlatformSkcs: asStringArray(row.listingPlatformSkcs),
    listingError: typeof row.listingError === 'string' ? row.listingError : '',
    listingShopId: typeof row.listingShopId === 'string' ? row.listingShopId : '',
    listingShopName: typeof row.listingShopName === 'string' ? row.listingShopName : '',
    listingCategoryPathLabel: typeof row.listingCategoryPathLabel === 'string' ? row.listingCategoryPathLabel : '',
    listingProductTemplateId: typeof row.listingProductTemplateId === 'string' ? row.listingProductTemplateId : '',
    listingProductTemplateName: typeof row.listingProductTemplateName === 'string' ? row.listingProductTemplateName : '',
    assessing: Boolean(row.assessing),
    riskAdvice: typeof row.riskAdvice === 'string' ? row.riskAdvice : '',
    infringementBatchId: row.infringementBatchId != null ? Number(row.infringementBatchId) : null,
    assessedAt: typeof row.assessedAt === 'string' ? row.assessedAt : '',
  };
}

export function setReceiveItemMeta(id, patch) {
  if (id == null) return;
  const map = { ...readReceiveMetaMap() };
  const key = String(id);
  const cur = map[key] && typeof map[key] === 'object' ? { ...map[key] } : {};
  map[key] = { ...cur, ...patch };
  writeReceiveMetaMap(map);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(RECEIVE_ITEM_META_EVENT));
  }
}

export function setReceiveItemMetaMany(ids, patch) {
  const list = Array.isArray(ids) ? ids.filter((id) => id != null) : [];
  if (!list.length) return;
  const map = { ...readReceiveMetaMap() };
  list.forEach((id) => {
    const key = String(id);
    const cur = map[key] && typeof map[key] === 'object' ? { ...map[key] } : {};
    map[key] = { ...cur, ...patch };
  });
  writeReceiveMetaMap(map);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(RECEIVE_ITEM_META_EVENT));
  }
}

export function clearReceiveItemMetaForLogout() {
  userLocal.dropLegacyKeys(STORAGE_KEY);
}
